import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'panel',
    loadChildren: () => import('./panel-subasta/panel-subasta.module').then(m => m.PanelSubastaModule)
  },
  {
    path: 'arribos',
    loadChildren: () => import('./arribos/arribos.module').then(m => m.ArribosPageModule)
  },
  {
    path: 'ventas',
    loadChildren: () => import('./ventas/ventas.module').then(m => m.VentasPageModule)
  },
  {
    path: '**',
    loadChildren: () => import('./splash/splash.module').then(m => m.SplashPageModule)
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
